import { PostMetadata } from "@/components/common/posts/post-metadata";

    export const posts: PostMetadata[] = [
    {
        title: "Africa Foto Fair 2025 – Grand-Bassam 🧡🤍💚",
        date: "11 Novembre 2025",
        heure: "9:35 pm",
        description: "Africa Foto Fair 2025 – Grand-Bassam 🧡🤍💚.",
        // image: "/images/actualites/flash-infos/default.png",
        image: "/images/actualites/evenements/2025/11/africa-foto-fair/accueil.jpg",
        slug: "2025/11/africa-foto-fair",
        aLaUne: true,
    },
    {
        title: "🎭🧡🤍💚 #Abissa2025 et Chasse au Trésor à Grand-Bassam 🇨🇮",
        date: "11 Novembre 2025",
        heure: "9:35 pm",
        description: "Grand-Bassam a vibré au rythme de l’Abissa 2025, un événement emblématique mêlant culture, traditions et patrimoine vivant.",
        image: "/images/actualites/flash-infos/default.png",
        // image: "/images/actualites/evenements/2025/11/abissa-chasse-tresor-grand-bassam/accueil.png",
        slug: "2025/11/abissa-chasse-tresor-grand-bassam",
        aLaUne: true,
        aLaUneSecondaire: true
    }
];
